<div style="white-space: normal;  overflow: hidden; text-overflow: ellipsis;">

  <h3>Debug</h3>

  <ul>
    <li>
      <div>GetUser</div>
      @if (this.debug1) {
        <div>OK</div>
      }
      @if (!this.debug1) {
        <div>NOT OK <button (click)="login()">Fix: Login</button></div>
      }
      <code>
        {{ this.debug1 | json }}
      </code>
    </li>
    <li >
      <div>VerifyJWT service.flow.microsoft.com</div>
      @if (token_flow) {
        <div>
          <div>OK</div>
          @if (tokenExpiry(token_flow); as exp) {
            <span [style.color]="exp.expired ? 'firebrick' : 'green'">
              {{ exp.expired ? '⚠ Expired' : '✓ Valid' }} (exp {{ exp.iso }})
            </span>
          }
          <code>
            {{ token_flow | json }}
          </code>
          <a href="https://jwt.ms/#access_token={{ token_flow?.secret }}" target="_blank">view on jwt.ms</a>
          <div>
            <button (click)="loginConsent()">Fix: Re-Grant Manage Flow permission</button>
          </div>
        </div>
      } @else {
        <div>NOT OK </div>
      }
    </li>
    <li >
      <div>VerifyJWT service.flow.microsoft.com</div>
      @if (token_flow_a) {
        <div>
          <div>OK</div>
          @if (tokenExpiry(token_flow_a); as exp) {
            <span [style.color]="exp.expired ? 'firebrick' : 'green'">
              {{ exp.expired ? '⚠ Expired' : '✓ Valid' }} (exp {{ exp.iso }})
            </span>
          }
          <code>
            {{ token_flow_a | json }}
          </code>
          <a href="https://jwt.ms/#access_token={{ token_flow_a?.secret }}" target="_blank">view on jwt.ms</a>
          <div>
            <button (click)="loginPowerAdmin()">Fix: Re-Grant Impersonate Flow permission (needs admin)</button>
          </div>
        </div>
      } @else {
        <div>NOT OK </div>
      }
    </li>
    <li>
      <div>VerifyJWT service.powerapps.com</div>
      @if (token_pa) {
        <div>
          <div>OK</div>
          @if (tokenExpiry(token_pa); as exp) {
            <span [style.color]="exp.expired ? 'firebrick' : 'green'">
              {{ exp.expired ? '⚠ Expired' : '✓ Valid' }} (exp {{ exp.iso }})
            </span>
          }
          <code>
            {{ token_pa | json }}
          </code>
          <a href="https://jwt.ms/#access_token={{ token_pa?.secret }}" target="_blank">view on jwt.ms</a>
          <div>
            <button (click)="loginPowerAppConsent()">Re-Grant Impersonate Power Apps permission</button>
          </div>
        </div>
      } @else {
        <div>NOT OK </div>
      }
    </li>
    <li>
      <div>CanAccess Flow Environment</div>
      <div>OK</div> {{ this.debug3 }}
    </li>
    <li>
      <div>Refreshed Flow Environment</div>
      @if ((this.debug4 | async)) {
        <div>OK</div>
        }{{ this.debug4 | async }}
      </li>
      <li>
        <div>MSAL Errors (blank is good)</div>
        @if ((this.debug5 == null)) {
          <div>OK</div>
          }{{ this.debug5 | json }}
        </li>
      </ul>

      @if (debug) {
        <div>
          <button (click)="getSolutions()">solutions</button>
          <button (click)="loginDynamicsConsent()">Fix: Dynamics Consent</button>
          <code>
            {{ this.debug6 | json }}
          </code>
          <ul>
            @for (solution of this.solutions; track solution) {
              <li>{{solution | json}}</li>
            }
          </ul>
          <div>
            {{this.error | json}}
          </div>
          <button (click)="getSolutionFlows()">solutions flows</button>
          <ul>
            @for (flow of this.flows; track flow) {
              <li>{{flow | json}}</li>
            }
          </ul>
          <button (click)="flowAuth()">request Flow auth</button>
          <button (click)="appAuth()">request App auth</button>
          <br>
          </div>
        }
        <br>
          <br>
            <br>

              <br>
                <br>

                  @if (isFlowStudioStaff) {
                    <div style="border: 1px solid #ccc; padding: 8px; margin: 8px 0;">
                      <h4>Lookup</h4>
                      <input type="text" [(ngModel)]="lookupQ" style="width: 360px;" name="lookupQ">
                      <button (click)="runLookup()" [disabled]="lookupBusy">{{ lookupBusy ? '…' : 'Lookup' }}</button>
                      @if (lookupError) {
                        <div style="color: firebrick;">
                          <code>{{ lookupError | json }}</code>
                        </div>
                      }
                      @if (lookupResult) {
                        <div>
                          <code>
                            {{ lookupResult | json }}
                          </code>
                        </div>
                      }
                    </div>
                  }

                  <span title="teachable moment">🦄</span><span title="=>">💨</span><span title="katkat">🌈</span>

                </div>
